import axios from 'axios';
import { BehaviorSubject } from 'rxjs';

import authService from './authService';

const TICKET_URL = process.env.REACT_APP_TICKET_APIRUL;

//createTicket
const createTicket = async (formData, userData) => {
  const config = {
    headers: {
      'Content-Type': 'application/json',
      authorization: userData.token,
    },
  };
  const result = await axios.post(`${TICKET_URL}`, formData, config);
  return result;
  /* console.log(config);
  console.log(formData);
  console.log(TICKET_URL); */
};
//getTicketById
const getTicketById = async (userData, id) => {
  const config = {
    headers: {
      'Content-Type': 'application/json',
      authorization: userData.token,
    },
  };

  const result = await axios.get(`${TICKET_URL}/${id}`, config);
  return result;
};
//getAllTickets

const getAllTickets = async (userData) => {
  const config = {
    headers: {
      'Content-Type': 'application/json',
      authorization: userData.token,
    },
  };
  const result = await axios.get(`${TICKET_URL}`, config);
  return result;
};
//updateTicket

const updateTicket = async (id, updateData, userData) => {
  const config = {
    headers: {
      'Content-Type': 'application/json',
      authorization: userData.token,
    },
  };

  const result = axios.patch(`${TICKET_URL}/${id}`, updateData, config);
  return result;
};
//deleteTicket

const ticketService = {
  createTicket,
  getAllTickets,
  getTicketById,
  updateTicket,
};

export default ticketService;
